// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowDownBoldOutline,
  mdiProgressDownload,
  mdiTableArrowUp,
} from '@mdi/js';
import {Order} from './interfaces';
import {checkMatchMedia} from '../../utils/helpers';

type Props = {
  ordersDispatch: any;
  data: Order[];
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    props.ordersDispatch({...props.filtersValues, page: undefined, size: 2000});
  };
  const flattData = (data: any) => {
    const newData = data.map(
      ({
        customerLat,
        customerLon,
        receiptUrl,
        partnerId,
        fulfillmentWarehouseId,
        fulfillmentWarehouseAddress,
        ...item
      }: any) => {
        return {
          ...item,
          deliveryDateFa:
            item.deliveryDate &&
            jMoment(item.deliveryDate, 'YYYY/M/D')
              .locale('fa')
              .format('jYY/jMM/jDD'),
          deliveryDate: item.deliveryDate,
          items: item.items?.map((item: any) => item.productName).join('& '),
          // items: item.items ? `${JSON.stringify(item?.items)?.replace(/['"]+/g, "'")}` : undefined,
          customerMobileNumber: item.customerMobileNumber + '',
          packages: undefined,
        };
      }
    );
    return newData;
  };

  return (
    <>
      {props.data.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="Orders.csv"
          style={{
            padding: '5px 13px',
            color: '#2F4858',
            marginLeft: '5px',
            textDecoration: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            border: '1px solid rgba(47, 72, 88, 0.5)',
            width: '100px',
          }}
          data-cy="downloadCSV"
        >
          <Icon path={mdiProgressDownload} size={1} />
          EXCEL
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '8px'}}
          variant="outlined"
          color="primary"
          startIcon={<Icon path={mdiArrowDownBoldOutline} size={'16px'} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
          size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'large'}
          data-cy="createCSV"
        >
          EXCEL
        </Button>
      )}
    </>
  );
}

export default CSV;
